import type { Trip } from '../types';

/**
 * What the server lets you do in this trip, read from the role it applies
 * (ADR-0033). The endpoints enforce it anyway; this only keeps the UI from
 * offering a button that answers 403.
 */
export function tripPermissions(trip: Pick<Trip, 'viewerRole'>): { isOwner: boolean; canEdit: boolean } {
  const isOwner = trip.viewerRole === 'OWNER';
  return { isOwner, canEdit: isOwner || trip.viewerRole === 'EDITOR' };
}

/**
 * ADR-0038: the suitcase, the expenses and the gallery are the travellers'; and
 * ADR-0039 the meals. Agency staff get 403 on them; the tabs are not even offered.
 */
export const AGENCY_HIDDEN_TABS = ['expenses', 'packing', 'gallery', 'meals'] as const;
export type AgencyHiddenTab = (typeof AGENCY_HIDDEN_TABS)[number];

export function hidesTab(trip: Pick<Trip, 'viewerIsAgency'>, tab: string): boolean {
  // ADR-0046: the album is built from the diary, so it hides with it.
  const section = tab === 'album' ? 'gallery' : tab;
  return trip.viewerIsAgency === true && (AGENCY_HIDDEN_TABS as readonly string[]).includes(section);
}
